/*
 * @Author: jin.li 1754611189@qq.com
 * @Date: 2025-07-10 16:14:43
 * @LastEditors: jin.li 1754611189@qq.com
 * @LastEditTime: 2025-07-14 09:26:20
 * @FilePath: \cbest-welfare-erp-h5\src\views\Product\components\BatchEditArea.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Modal, Button, Input, Select, Form, message } from "antd";
import { useEffect, useState } from "react";
import service from "../../../@services";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ visible, idList, storeId, close = () => { } }) => {
    const [form] = Form.useForm();
    const [areaOptions, setAreaOptions] = useState([]);
    const [deliveryArea, setDeliveryArea] = useState(null);
    const handleSearch = async (newValue) => {
        if (newValue) {
            const params = {
                pageNum: 1,
                pageSize: 20,
                templateName: newValue,
            };
            const data = await service.area.getAreaPageList(params);
            setAreaOptions(data.result)
        } else {
            setAreaOptions([]);
        }
    };
    const handleChange = (newValue) => { 
        form.setFieldsValue({
            deliveryArea: newValue,
        });
        setDeliveryArea(newValue);
    };

    const confirm = async () => {
        try {
            await form.validateFields();
            const params = {
                skuIds: idList,
                areaModelId: deliveryArea,
                storeId: storeId,
            }
            const res = await service.product.updateBatchArea(params);
            message.success('操作成功');
            close(true);
            await form.resetFields();
        } catch (errorInfo) {
            console.log(errorInfo);
        }
        
    }

    return (
        <Modal
            title="批量编辑可售模板"
            visible={visible}
            onCancel={close}
            footer={[
                <Button key="back" onClick={confirm}>确认</Button>
            ]}
        >
            <Form
                form={form}
                labelCol={{ span: 5 }}
                initialValues={{
                    status: 1
                }}
            >
                <Form.Item
                    label="商品数量"
                    rules={[{ required: true, message: "请输入模板名称" }]}
                >
                    {idList.length}
                </Form.Item>
                <Form.Item
                    name="deliveryAreaName"
                    label="可售区域模板"
                    rules={[{ required: true, message: "请选择模板" }]}
                >
                    <Select
                        showSearch
                        placeholder='请输入模板名称进行查询'
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearch}
                        onChange={handleChange}
                        notFoundContent={null}
                        options={(areaOptions || []).map((item) => {
                            return {
                                value: item.id,
                                label: item.templateName
                            }
                        })}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}
